import { TransferErrorIcon } from '@/components/buttons/Transfer/TransferErrorIcon';
import { TransferState } from '@/components/buttons/TransferBulk/TransferBulk.types';
import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';
import { Dispatch, SetStateAction } from 'react';

type Props = {
  onClose(): void;
  setTransferState: Dispatch<SetStateAction<TransferState>>;
};

export const TransferBulkError = ({ onClose, setTransferState }: Props) => {
  const { t } = useTranslation('account');

  return (
    <Flex flexDir="column" gap="space.12">
      <Heading fontSize="2xl" fontWeight="normal">
        {t('assets.bulk-transfer.error.title')}
      </Heading>
      <Flex flexDir="column" gap="space.32">
        <Text color="gray.6">{t('assets.bulk-transfer.error.description')}</Text>
        <TransferErrorIcon boxSize={rem(156)} mx="auto" />
        <Flex w="full" gap="space.24">
          <Button onClick={onClose} w="full" variant="secondary">
            {t('assets.bulk-transfer.error.cta.close')}
          </Button>
          <Button onClick={() => setTransferState(TransferState.IDLE)} w="full">
            {t('assets.bulk-transfer.error.cta.retry')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
